import logo from "calc-common-assets/CSCU-logo.png";
import waves from "calc-common-assets/CSCU-wave.png";
import "calc-common-styles/App.scss";
import "calc-common-styles/bootstrap.min.css";
import Header from "shared/src/structure/HeaderTwo";
import Footer from "./structure/FooterClean";
import React, { lazy, Suspense, useEffect } from "react";
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect,
  useLocation,
} from "react-router-dom";
import PageBody from "shared/src/structure/BodyWrapper";
//Import route pages
import Home from "./Home";
import BodyLoading from "shared/src/structure/BodyLoading";
//Import unique styles
import "../styles/App.scss";
//Import redux connector
import { connect } from "react-redux";
//Tag manager code
import { appVersion } from "shared/src/misc/constants";
import TagManager from "react-gtm-module";
const tagManagerArtgs = {
  gtmId: "GTM-MN4J35B",
};
TagManager.initialize(tagManagerArtgs);

function App() {
  useEffect(() => {
    console.log("Initialized form version: " + appVersion);
  }, []);
  return (
    <div className="App">
      <Header
        logo={logo}
        title="Learn more about our RESP offer"
        bookMeeting={false}
      />
      <Router basename="/contact-us">
        <PageBody>
          <ConnectedAppSwitch />
        </PageBody>
      </Router>
      <Footer background={waves}></Footer>
    </div>
  );
}

function AppSwitch(props) {
  const Complete = lazy(() => import("./Complete"));
  usePageViews();
  return (
    <Switch>
      <Suspense fallback={<BodyLoading />}>
        <Route exact path="/" component={Home} />
        {/* <Route exact path="/successdev" component={Complete}></Route> */}
        <Route exact path="/success">
          {props.submitted ? <Complete /> : <Redirect to="/" />}
        </Route>
      </Suspense>
    </Switch>
  );
}

function usePageViews() {
  let location = useLocation();
  useEffect(() => {
    //Disabling page views
    // const ga = getGA()
    // ga.set?.('page',location.pathname + location.search)
    // ga.send?.('pageview')
  }, [location]);
}

function mapStateToprops({ usrfields }) {
  return {
    submitted: usrfields.submitted || false,
  };
}

let ConnectedAppSwitch = connect(mapStateToprops)(AppSwitch);

export default App;
